<template>
  <b-form-group v-bind="$attrs">
    <b-form-textarea v-bind="$attrs" v-on="$listeners" />
  </b-form-group>
</template>
<script>

/**
 * ac Text Area component
 * @requires VueBootstrap
 */

export default {
  name: 'ac-text-area',
}
</script>
